// Piglin override (MOB-2 neutral, M20). PURE (ENG-1).
//
// A bartering piglin is neutral: it wanders peacefully and only fights once
// provoked (a player hit arms `angerTimer` via EntitySystem.damage). While angry
// it chases and strikes the nearest player like any melee hostile; when calm it
// mills about. The "gold-armour calm" state table proper lives in game/piglin.ts.
import type { MobDef } from '../../registry/schemas';
import type { Entity, MobContext } from '../entity';
import { meleeAI } from '../archetypes/melee';
import { wander } from '../archetypes/shared';

export function piglin(e: Entity, def: MobDef, ctx: MobContext): void {
  // Provoked: chase and bite the nearest player while the anger window lasts.
  if (e.angerTimer > 0 && meleeAI(e, def, ctx)) return;
  wander(e, ctx, def);
}
